/*
 * @Date: 2023-04-10 12:58:17
 * @LastEditors: simLarry
 * @LastEditTime: 2023-04-26 12:39:07
 * @FilePath: \P1-M1-QRP-CODE\utils\hooks\useRegister.js
 */
import { useRequest } from 'ahooks';
import { fetchRequest } from '$CONFIG/Fatch.config';
import { Cookie, getBrowserVersion } from '$ACTIONS/util';
import { ApiPort } from '$ACTIONS/API';
import { getPlatform } from '../../config/Fatch.config';
import { getSeonSession } from '../helpers/SEON';

const postRegister = async ({ password, mobile, username, affiliateCode = '', email = '', challengeUuid = '' }) => {
    const platform = getPlatform();
    let params = {
        password,
        mobile,
        username,
        memberCode: username,
        email,
        referer: Cookie.GetCookieKeyValue('Referer') || window.location.origin,
        hostName: window.location.origin,
        blackBoxValue: window.E2GetBlackbox?.().blackbox || '',
        deviceSignatureBlackBox: window.E2GetBlackbox?.().blackbox || '',
        language: 'ZH-CN',
        mediaCode: Cookie.GetCookieKeyValue('Media') || null,
        affiliateCode,
        regWebsite: platform === 'Desktop' ? 16 : 17,
        brandCode: 'BETWAY',
        currency: 'CNY',
        challengeUuid,
        fraudSignature: await getSeonSession(),
        // websiteId: getBrowserVersion(),
    }
    return fetchRequest(ApiPort.Register, 'POST', params);
}


const useRegister = ({ onBefore, onSuccess, onError }) => {
    return useRequest(postRegister, {
        manual: true,
        onBefore: () => {
            if (typeof onBefore === 'function') {
                onBefore();
            }
            global.globalGtag('Register', 'Submit', 'Submit_Register');
            global.globalConsole("useRegister onBefore")
        },
        onSuccess: (result, params) => {
            if (typeof onSuccess === 'function') {
                onSuccess(result, params);
            }
            global.globalConsole("useRegister onSuccess", result, params)
        },
        onError: (error) => {
            if (typeof onError === 'function') {
                onError(error);
            }
            global.globalConsole("useRegister onError", error)
        },
    });
}

export default useRegister
